"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMenuItemSwitch_unstable", {
    enumerable: true,
    get: function() {
        return useMenuItemSwitch_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _useMenuItemCheckbox = require("../MenuItemCheckbox/useMenuItemCheckbox");
const _reacticons = require("@fluentui/react-icons");
const _useMenuItemSwitchStylesstyles = require("./useMenuItemSwitchStyles.styles");
const useMenuItemSwitch_unstable = (props, ref)=>{
    const baseState = (0, _useMenuItemCheckbox.useMenuItemCheckbox_unstable)(props, ref);
    return {
        ...baseState,
        switchIndicator: _reactutilities.slot.optional(props.switchIndicator, {
            renderByDefault: true,
            elementType: 'span',
            defaultProps: {
                children: /*#__PURE__*/ _react.createElement(_reacticons.CircleFilled, {
                    className: _useMenuItemSwitchStylesstyles.circleFilledClassName
                })
            }
        }),
        components: {
            ...baseState.components,
            switchIndicator: 'span'
        }
    };
};
